module.exports = __webpack_public_path__ + "static/media/4dadc0cb-7bfa-441a-be83-37a7e8500962.bbffbc7d.png";